import { api } from './client';

/**
 * Разбивка результата insights
 */
export interface InsightBreakdownResult {
  dimension_values: string[];
  value: number;
  end_time?: string;
}

export interface InsightBreakdown {
  dimension_keys: string[];
  results: InsightBreakdownResult[];
}

export interface InsightTotalValue {
  value?: number;
  breakdowns?: InsightBreakdown[];
}

/**
 * Одна метрика insights
 */
export interface InsightMetric {
  name: string;
  period: string;
  title: string;
  description: string;
  total_value?: InsightTotalValue;
  values?: Array<{
    value: number;
    end_time: string;
  }>;
  id: string;
}

/**
 * Ответ Instagram API для account insights
 */
export interface AccountInsightsResponse {
  data: InsightMetric[];
  paging?: {
    previous?: string;
    next?: string;
  };
}

/**
 * Опции для запроса account insights
 */
export interface AccountInsightsOptions {
  metric?: string; // список метрик через запятую
  period?: 'day' | 'week' | 'days_28' | 'lifetime';
  metricType?: 'total_value' | 'time_series';
  breakdown?: 'media_product_type' | 'follow_type' | 'contact_button_type' | 'gender' | 'age' | 'city' | 'country' | 'age,gender';
  timeframe?: 'last_14_days' | 'last_30_days' | 'last_90_days' | 'this_month' | 'this_week' | 'prev_month';
  since?: string; // Unix timestamp
  until?: string; // Unix timestamp
}

export const accountInsightsAPI = {
  /**
   * Получить insights для аккаунта Instagram
   */
  getAccountInsights: async (
    accountId: string,
    options?: AccountInsightsOptions
  ): Promise<AccountInsightsResponse> => {
    // Формируем параметры для передачи в клиент API
    const params: Record<string, string> = {};
    
    if (options?.metric) params.metric = options.metric;
    if (options?.period) params.period = options.period;
    if (options?.metricType) params.metricType = options.metricType;
    if (options?.breakdown) params.breakdown = options.breakdown;
    if (options?.timeframe) params.timeframe = options.timeframe;
    if (options?.since) params.since = options.since;
    if (options?.until) params.until = options.until;
    
    const url = `/account-insights/account/${accountId}`;
    
    return api.get<AccountInsightsResponse>(url, { params });
  },
};